import styled from 'styled-components';
import colors from 'styles/colors';

export const StyledParagraph = styled.p`
  font-size: 20px;
  color: ${colors.Gray20};
  text-align: center;
  font-weight: bold;
  line-height: 1.5;
  margin: 0;
`;